var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-outline-primary mr-1",on:{"click":_vm.onClicked}},[_vm._v(" "+_vm._s(_vm.name)+" "),_c('i',{staticClass:"fas fa-times"})])}
var staticRenderFns = []

export { render, staticRenderFns }